export default __webpack_public_path__ + "static/media/content_upload.56bfb461.svg";